// Color options for categories used across the application
export const colorOptions = [
  '#FF6B6B', '#4ECDC4', '#45B7D1', '#96CEB4', '#FFEAA7', 
  '#DDA0DD', '#98D8C8', '#FF8A80', '#82B1FF', '#B39DDB',
  '#F06292', '#AED581', '#FFD54F', '#FF8A65', '#4DD0E1',
  '#9575CD', '#81C784', '#FFB74D', '#E57373', '#64B5F6'
];

// Helper function to get a random color from the color options
export const getRandomColor = () => {
  return colorOptions[Math.floor(Math.random() * colorOptions.length)];
};

